import { mapState, mapGetters, mapActions } from 'vuex'

export const measureListComputed = {
  ...mapState('measureList', {
    loading: (state) => state.loading,
  }),
  ...mapGetters('measureList', ['getMeasureList', 'getMeasureListById']),
}

export const measureListMethods = mapActions('measureList', [
  'fetchingMeasureList',
  'resetMeasureList',
  'deleteMeasureById',
  'exportMeasureCsv',
])
